import { CallCenterSelectorComponent } from "./components/call-center-selector/call-center-selector.component";
import { CampaignGuard } from "@app/campaign.guard";
import { F2fSelectorComponent } from "./components/f2f-selector/f2f-selector.component";
import { FormModule } from "@app/components/form/form.module";
import { GATrackPathDirective } from "@app/directives/gatrack-path.directive";
import { HomeCategoriesComponent } from "./components/home-categories/home-categories.component";
import { HomeComponent } from "./home.component";
import { HomeProductsComponent } from "./components/home-products/home-products.component";
import { LegacyModule } from "shared/legacy.module";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyCardModule as MatCardModule } from "@angular/material/legacy-card";
import { MatDialogModule } from "@angular/material/dialog";
import {MatExpansionModule} from '@angular/material/expansion';
import { MatIconModule } from "@angular/material/icon";
import { MatStepperModule } from "@angular/material/stepper";
import { ModalModule } from "@app/components/modal/modal.module";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { SearcherComponent } from "./components/searcher/searcher.component";
import { SharedModule } from "shared/shared.module";

@NgModule({
  declarations: [
    HomeComponent,
    CallCenterSelectorComponent,
    F2fSelectorComponent,
    HomeCategoriesComponent,
    HomeProductsComponent,
    SearcherComponent,
    GATrackPathDirective,
  ],
  imports: [
    SharedModule,
    LegacyModule,
    ModalModule,
    FormModule,
    MatCardModule,
    MatDialogModule,
    MatExpansionModule,
    MatIconModule,
    MatButtonModule,
    MatStepperModule,
    [
      RouterModule.forChild([
        {
          path: "",
          component: HomeComponent,
          canActivate: [CampaignGuard],
        },
      ]),
    ],
  ],
})
export class HomeModule {}
